<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      <div style="text-align: center;">
        <h2>{{this.name}}</h2> 
      </div>
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <div class="section-new-doc"> 
              <img
                class="cross-circle-img"
                src="@/assets/download.svg"
                alt
              /> 
              <a :href="this.fileurl" style="text-decoration: none;"><span class="add-new-document">Download Document</span></a>
            </div>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: "companyPoliciesDocument",
  props: {
    document: {
      type: Object
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      name:null,
      fileurl:[],

    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
    this.showdata();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
    this.showdata();
  },

  methods: {
    showdata(){
      ////console.log("my doc",this.document)
      this.name=this.document.payload[0].policy_name;
      this.fileurl=this.document.payload[0].policy_url;
      //console.log("this is a name",this.name);
    //  //console.log("file url array",this.fileurl)

    }
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.section-new-doc {
  cursor: pointer;
  display: inherit;
}

.cross-circle-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
</style>
